import type { ChoiceCardOption } from '../../atoms/ChoiceCardGroup/ChoiceCardGroupAtom';
import { resolveFactorDisplayName } from '../../../utils/factorDisplay';
import { buildReadsAsSentence, type ReadsAsTranslateFn } from '../RollupSetCard/readsAsSentence';
import type { MeasureFactor } from './useMeasureFactors';

/**
 * One choice card per rollup a measure defines. The label is the name the factor list shows for
 * the same factor (the owner's name, else "Related Spheres"), so the sheet and the Status Factors
 * tab never disagree; the note is the rollup's own READS AS sentence, which is what tells two
 * same-named rollups apart.
 */
export function measureFactorChoices(factors: MeasureFactor[], t: ReadsAsTranslateFn, locale?: string): ChoiceCardOption[] {
  const typeLabel = t('statusFactors.types.relatedSpheres.label', 'Related Spheres');
  return factors.map((factor) => ({
    value: factor.id,
    label: resolveFactorDisplayName(factor, typeLabel),
    note: buildReadsAsSentence({ set: factor.set, t, locale }),
  }));
}
